import React from "react";
import { Col, Container, Row, Tab, Nav } from "react-bootstrap";

function Highdemandslider() {
  return (
    <section
      className="high_demand_slider p-100 cloud_innovate_power"
      style={{ background: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>
              Cloud Innovation to Power-Up <span>Operational Prowess</span>
            </h2>
            <p>
              Our cloud consultancy services are designed to drive digital
              transformation and optimize your business operations. Here's why
              TekRevol is your ideal cloud consulting company.
            </p>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="demand_item">
                  <h5>Expert Guidance</h5>
                  <p>
                    Benefit from our unmatched expertise in cloud consulting,
                    ensuring a seamless transition and efficient utilization of
                    cloud resources.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="demand_item">
                  <h5>Robust Security</h5>
                  <p>
                    With a focus on high-end security measures, we prioritize
                    data protection and compliance for safe and resourceful
                    cloud migration services.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="demand_item">
                  <h5>Continuous Innovation</h5>
                  <p>
                    Stay ahead with our commitment to constant innovation,
                    leveraging the latest cloud technologies to enhance
                    performance and scalability.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="demand_item">
                  <h5>Maturity Assessment</h5>
                  <p>
                    Gain insights into your cloud maturity level through our
                    comprehensive assessment, enabling targeted improvements and
                    optimizations.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="demand_item">
                  <h5>Cost Optimization</h5>
                  <p>
                    We optimize costs without compromising quality, implementing
                    strategies to maximize ROI and reduce operational expenses.
                  </p>
                </div>
              </Col>
              <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
                <div className="demand_item">
                  <h5>Accelerated Time-to-Market</h5>
                  <p>
                    Our streamlined processes and agile methodologies ensure
                    faster deployment and time-to-market, giving you a
                    competitive edge.
                  </p>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Highdemandslider;
